// Get visible learning objectives

export default (courses_dow) => {
    return courses_dow
  };